import { applicationPdfPagePath } from "src/app/shared/routes/application/term-life-insurance/application-route.constant";
import { allFunnelHeaderMilestones } from "src/app/shared/routes/global-route.constant";
import {
  beneficiaryPagePath,
  dateOfBirthPagePath,
  emailPagePath,
  genderPagePath,
  insuranceTermPagePath,
  insuredSumPagePath,
  occupationsPagePath,
  optionalEmailPagePath,
  personalDetailsPagePath,
  premiumPagePath,
  smokerPagePath,
  summaryPagePath,
  underwritingBmiPagePath,
  underwritingQuestionsPagePath,
} from "src/app/shared/routes/quote/term-life-insurance/quote-route.constant";
import {
  CustomRoute,
  getFullHtmlTitle,
  Page,
  TermLifeInsuranceSharedFunnelStepNumber,
  Type,
} from "src/app/shared/routes/shared/shared-route.constant";
import { createSkipDigitalApplicationPagesGuard } from "../../shared/guards/skip-digital-application-pages.guard";
import { extractQueryStringParametersResolver } from "../../shared/resolvers/extract-query-string-parameters.resolver";
import { funnelHeaderMilestonesResolver } from "../../shared/resolvers/get-funnel-header-milestones.resolver";
import { getTermLifeInsuranceQuoteWithProductConfigurationResolver } from "../../shared/resolvers/get-term-life-insurance-quote-with-product-configuration.resolver";
import { Product } from "../services/backend/dto/enums/product.enum";

export const quoteTermLifeInsuranceRoutes: CustomRoute[] = [
  {
    path: optionalEmailPagePath,
    loadComponent: () =>
      import(
        "../../shared/pages/legacy/optional-email/optional-email.page"
      ).then((m) => m.OptionalEmailPage),
    data: {
      type: Type.PRODUCT_SPECIFIC,
      product: Product.TERM_LIFE_INSURANCE_CONSTANT,
      page: Page.QUOTE_OPTIONAL_EMAIL,
      htmlTitle: getFullHtmlTitle($localize`E-Mail (Optional)`),
      pageTitle: $localize`Schön, Sie kennenzulernen!`,
      pageSubtitle: $localize`Dank der Angabe Ihrer E-Mail-Adresse können Sie in Zukunft jederzeit auf Ihr Angebot zurückgreifen.`,
      funnelHeaderMilestones: allFunnelHeaderMilestones,
      navigation: {
        nextNavigationPage: {
          pagePath: genderPagePath,
        },
      },
      dataAnalytics: {
        funnelStepNumber:
          TermLifeInsuranceSharedFunnelStepNumber.QUOTE_OPTIONAL_EMAIL,
      },
    },
    resolve: {
      termLifeInsuranceQuote:
        getTermLifeInsuranceQuoteWithProductConfigurationResolver,
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver:
        extractQueryStringParametersResolver,
    },
  },
  {
    path: genderPagePath,
    loadComponent: () =>
      import("../../shared/pages/legacy/gender/gender.page").then(
        (m) => m.GenderPage,
      ),
    data: {
      type: Type.PRODUCT_SPECIFIC,
      product: Product.TERM_LIFE_INSURANCE_CONSTANT,
      page: Page.QUOTE_GENDER,
      htmlTitle: getFullHtmlTitle($localize`Geschlecht`),
      pageTitle: $localize`Sind Sie ein Mann oder eine Frau?`,
      funnelHeaderMilestones: allFunnelHeaderMilestones,
      navigation: {
        previousNavigationPage: {
          pagePath: optionalEmailPagePath,
        },
        nextNavigationPage: {
          pagePath: dateOfBirthPagePath,
        },
      },
      dataAnalytics: {
        funnelStepNumber: TermLifeInsuranceSharedFunnelStepNumber.QUOTE_GENDER,
      },
    },
    resolve: {
      termLifeInsuranceQuote:
        getTermLifeInsuranceQuoteWithProductConfigurationResolver,
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver:
        extractQueryStringParametersResolver,
    },
  },
  {
    path: dateOfBirthPagePath,
    loadComponent: () =>
      import("../../shared/pages/legacy/date-of-birth/date-of-birth.page").then(
        (m) => m.DateOfBirthPage,
      ),
    data: {
      type: Type.PRODUCT_SPECIFIC,
      product: Product.TERM_LIFE_INSURANCE_CONSTANT,
      page: Page.QUOTE_DATE_OF_BIRTH,
      htmlTitle: getFullHtmlTitle($localize`Geburtstag`),
      pageTitle: $localize`Wann wurden Sie geboren?`,
      funnelHeaderMilestones: allFunnelHeaderMilestones,
      navigation: {
        previousNavigationPage: {
          pagePath: genderPagePath,
        },
        nextNavigationPage: {
          pagePath: smokerPagePath,
        },
      },
      dataAnalytics: {
        funnelStepNumber:
          TermLifeInsuranceSharedFunnelStepNumber.QUOTE_DATE_OF_BIRTH,
      },
    },
    resolve: {
      termLifeInsuranceQuote:
        getTermLifeInsuranceQuoteWithProductConfigurationResolver,
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver:
        extractQueryStringParametersResolver,
    },
  },
  {
    path: smokerPagePath,
    loadComponent: () =>
      import("../../shared/pages/legacy/smoker/smoker.page").then(
        (m) => m.SmokerPage,
      ),
    data: {
      type: Type.PRODUCT_SPECIFIC,
      product: Product.TERM_LIFE_INSURANCE_CONSTANT,
      page: Page.QUOTE_SMOKER,
      htmlTitle: getFullHtmlTitle($localize`Raucher`),
      pageTitle: $localize`Rauchen Sie?`,
      funnelHeaderMilestones: allFunnelHeaderMilestones,
      navigation: {
        previousNavigationPage: {
          pagePath: dateOfBirthPagePath,
        },
        nextNavigationPage: {
          pagePath: insuredSumPagePath,
        },
      },
      dataAnalytics: {
        funnelStepNumber: TermLifeInsuranceSharedFunnelStepNumber.QUOTE_SMOKER,
      },
    },
    resolve: {
      termLifeInsuranceQuote:
        getTermLifeInsuranceQuoteWithProductConfigurationResolver,
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver:
        extractQueryStringParametersResolver,
    },
  },
  {
    path: insuredSumPagePath,
    loadComponent: () =>
      import("../../shared/pages/legacy/insured-sum/insured-sum.page").then(
        (m) => m.InsuredSumPage,
      ),
    data: {
      type: Type.PRODUCT_SPECIFIC,
      product: Product.TERM_LIFE_INSURANCE_CONSTANT,
      page: Page.QUOTE_INSURED_SUM,
      htmlTitle: getFullHtmlTitle($localize`Versicherungssumme`),
      pageTitle: $localize`Versicherungssumme`,
      pageSubtitle: $localize`Auch Todesfallkapital genannt. Der Betrag, der im Todesfall an die Begünstigten ausbezahlt wird.`,
      funnelHeaderMilestones: allFunnelHeaderMilestones,
      navigation: {
        previousNavigationPage: {
          pagePath: smokerPagePath,
        },
        nextNavigationPage: {
          pagePath: insuranceTermPagePath,
        },
      },
      dataAnalytics: {
        funnelStepNumber:
          TermLifeInsuranceSharedFunnelStepNumber.QUOTE_INSURED_SUM,
      },
    },
    resolve: {
      termLifeInsuranceQuote:
        getTermLifeInsuranceQuoteWithProductConfigurationResolver,
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver:
        extractQueryStringParametersResolver,
    },
  },
  {
    path: insuranceTermPagePath,
    loadComponent: () =>
      import(
        "../../shared/pages/legacy/duration-in-years/insurance-term-in-years.page"
      ).then((m) => m.InsuranceTermInYearsPage),
    data: {
      type: Type.PRODUCT_SPECIFIC,
      product: Product.TERM_LIFE_INSURANCE_CONSTANT,
      page: Page.QUOTE_INSURANCE_TERM,
      htmlTitle: getFullHtmlTitle($localize`Laufzeit`),
      pageTitle: $localize`Laufzeit`,
      pageSubtitle: $localize`Die Versicherungslaufzeit entspricht dem Zeitraum für den Sie abgesichert sind.`,
      funnelHeaderMilestones: allFunnelHeaderMilestones,
      navigation: {
        previousNavigationPage: {
          pagePath: insuredSumPagePath,
        },
        nextNavigationPage: {
          pagePath: premiumPagePath,
        },
      },
      dataAnalytics: {
        funnelStepNumber:
          TermLifeInsuranceSharedFunnelStepNumber.QUOTE_INSURANCE_TERM,
      },
    },
    resolve: {
      termLifeInsuranceQuote:
        getTermLifeInsuranceQuoteWithProductConfigurationResolver,
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver:
        extractQueryStringParametersResolver,
    },
  },
  {
    path: premiumPagePath,
    loadComponent: () =>
      import("../../shared/pages/premium/premium.page").then(
        (m) => m.PremiumPage,
      ),
    data: {
      type: Type.PRODUCT_SPECIFIC,
      product: Product.TERM_LIFE_INSURANCE_CONSTANT,
      page: Page.QUOTE_PREMIUM,
      htmlTitle: getFullHtmlTitle($localize`Prämie`),
      funnelHeaderMilestones: allFunnelHeaderMilestones,
      navigation: {
        previousNavigationPage: {
          pagePath: insuranceTermPagePath,
        },
        nextNavigationPage: {
          pagePath: emailPagePath,
        },
      },
      dataAnalytics: {
        funnelStepNumber: TermLifeInsuranceSharedFunnelStepNumber.QUOTE_PREMIUM,
      },
    },
    resolve: {
      termLifeInsuranceQuote:
        getTermLifeInsuranceQuoteWithProductConfigurationResolver,
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver:
        extractQueryStringParametersResolver,
    },
  },
  {
    path: emailPagePath,
    loadComponent: () =>
      import("../../shared/pages/legacy/email/email.page").then(
        (m) => m.EmailPage,
      ),
    data: {
      type: Type.PRODUCT_SPECIFIC,
      product: Product.TERM_LIFE_INSURANCE_CONSTANT,
      page: Page.QUOTE_EMAIL,
      htmlTitle: getFullHtmlTitle($localize`E-Mail`),
      pageTitle: $localize`Schön, dass Sie vorsorgen!`,
      pageSubtitle: $localize`Schliessen Sie Ihre Versicherung in wenigen Minuten online ab.`,
      funnelHeaderMilestones: allFunnelHeaderMilestones,
      navigation: {
        previousNavigationPage: {
          pagePath: premiumPagePath,
        },
        nextNavigationPage: {
          pagePath: underwritingBmiPagePath,
        },
      },
      dataAnalytics: {
        funnelStepNumber: TermLifeInsuranceSharedFunnelStepNumber.QUOTE_EMAIL,
      },
    },
    resolve: {
      termLifeInsuranceQuote:
        getTermLifeInsuranceQuoteWithProductConfigurationResolver,
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver:
        extractQueryStringParametersResolver,
    },
  },
  {
    path: underwritingBmiPagePath,
    loadComponent: async () =>
      (
        await import(
          "../../shared/pages/underwriting-bmi/underwriting-bmi.page"
        )
      ).UnderwritingBmiPage,
    data: {
      type: Type.PRODUCT_SPECIFIC,
      product: Product.TERM_LIFE_INSURANCE_CONSTANT,
      page: Page.QUOTE_UNDERWRITING_BMI,
      htmlTitle: getFullHtmlTitle($localize`BMI`),
      pageTitle: $localize`Body-Mass-Index`,
      pageSubtitle: $localize`Alle Angaben werden vertraulich behandelt.`,
      funnelHeaderMilestones: allFunnelHeaderMilestones,
      navigation: {
        previousNavigationPage: {
          pagePath: emailPagePath,
        },
        nextNavigationPage: {
          pagePath: underwritingQuestionsPagePath,
        },
      },
      dataAnalytics: {
        funnelStepNumber:
          TermLifeInsuranceSharedFunnelStepNumber.QUOTE_UNDERWRITING_BMI,
      },
    },
    resolve: {
      termLifeInsuranceQuote:
        getTermLifeInsuranceQuoteWithProductConfigurationResolver,
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver:
        extractQueryStringParametersResolver,
    },
  },
  {
    path: underwritingQuestionsPagePath,
    loadComponent: async () =>
      (
        await import(
          "../../shared/pages/underwriting-questions/underwriting-questions.page"
        )
      ).UnderwritingQuestionsPage,
    data: {
      type: Type.PRODUCT_SPECIFIC,
      product: Product.TERM_LIFE_INSURANCE_CONSTANT,
      page: Page.QUOTE_UNDERWRITING_QUESTIONS,
      htmlTitle: getFullHtmlTitle($localize`Leben und Gesundheit`),
      pageTitle: $localize`Leben und Gesundheit`,
      pageSubtitle: $localize`Bitte machen Sie folgende Angaben zu Ihrer Gesundheit`,
      funnelHeaderMilestones: allFunnelHeaderMilestones,
      navigation: {
        previousNavigationPage: {
          pagePath: underwritingBmiPagePath,
        },
        nextNavigationPage: {
          pagePath: beneficiaryPagePath,
        },
      },
      dataAnalytics: {
        funnelStepNumber:
          TermLifeInsuranceSharedFunnelStepNumber.QUOTE_UNDERWRITING_QUESTIONS,
      },
    },
    resolve: {
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver:
        extractQueryStringParametersResolver,
    },
    canActivate: [
      createSkipDigitalApplicationPagesGuard(
        getTermLifeInsuranceQuoteWithProductConfigurationResolver,
      ),
    ],
  },
  {
    path: beneficiaryPagePath,
    loadComponent: async () =>
      (await import("../../shared/pages/beneficiary/beneficiary.page"))
        .BeneficiaryPage,
    data: {
      type: Type.PRODUCT_SPECIFIC,
      product: Product.TERM_LIFE_INSURANCE_CONSTANT,
      page: Page.QUOTE_BENEFICIARY,
      htmlTitle: getFullHtmlTitle($localize`Begünstigung`),
      pageTitle: $localize`Begünstigung`,
      pageSubtitle: $localize`Wen möchten Sie im Fall der Fälle begünstigen?`,
      funnelHeaderMilestones: allFunnelHeaderMilestones,
      navigation: {
        previousNavigationPage: {
          pagePath: underwritingQuestionsPagePath,
        },
        nextNavigationPage: {
          pagePath: personalDetailsPagePath,
        },
      },
      dataAnalytics: {
        funnelStepNumber:
          TermLifeInsuranceSharedFunnelStepNumber.QUOTE_BENEFICIARY,
      },
    },
    resolve: {
      termLifeInsuranceQuote:
        getTermLifeInsuranceQuoteWithProductConfigurationResolver,
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver:
        extractQueryStringParametersResolver,
    },
  },
  {
    path: personalDetailsPagePath,
    loadComponent: async () =>
      (await import("../../shared/pages/person-details/personal-details.page"))
        .PersonalDetailsPage,
    data: {
      type: Type.PRODUCT_SPECIFIC,
      product: Product.TERM_LIFE_INSURANCE_CONSTANT,
      page: Page.QUOTE_PERSONAL_DETAILS,
      htmlTitle: getFullHtmlTitle($localize`Ihre Anschrift`),
      pageTitle: $localize`Ihre Anschrift`,
      funnelHeaderMilestones: allFunnelHeaderMilestones,
      navigation: {
        previousNavigationPage: {
          pagePath: beneficiaryPagePath,
        },
        nextNavigationPage: {
          pagePath: occupationsPagePath,
        },
      },
      dataAnalytics: {
        funnelStepNumber:
          TermLifeInsuranceSharedFunnelStepNumber.QUOTE_PERSONAL_DETAILS,
      },
    },
    resolve: {
      termLifeInsuranceQuote:
        getTermLifeInsuranceQuoteWithProductConfigurationResolver,
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver:
        extractQueryStringParametersResolver,
    },
  },
  {
    path: occupationsPagePath,
    loadComponent: async () =>
      (await import("../../shared/pages/occupation/occupation.page"))
        .OccupationPage,
    data: {
      type: Type.PRODUCT_SPECIFIC,
      product: Product.TERM_LIFE_INSURANCE_CONSTANT,
      page: Page.QUOTE_OCCUPATION,
      htmlTitle: getFullHtmlTitle($localize`Erwerbstätigkeit`),
      pageTitle: $localize`Erwerbstätigkeit`,
      pageSubtitle: $localize`Bitte geben Sie Ihre aktuelle Erwerbstätigkeit an. Die Angabe muss nicht zwingend Ihrem gelernten Beruf entsprechen.`,
      funnelHeaderMilestones: allFunnelHeaderMilestones,
      navigation: {
        previousNavigationPage: {
          pagePath: personalDetailsPagePath,
        },
        nextNavigationPage: {
          pagePath: summaryPagePath,
        },
      },
      dataAnalytics: {
        funnelStepNumber:
          TermLifeInsuranceSharedFunnelStepNumber.QUOTE_OCCUPATION,
      },
    },
    resolve: {
      termLifeInsuranceQuote:
        getTermLifeInsuranceQuoteWithProductConfigurationResolver,
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver:
        extractQueryStringParametersResolver,
    },
  },
  {
    path: summaryPagePath,
    loadComponent: async () =>
      (await import("../../shared/pages/summary/summary.page")).SummaryPage,
    data: {
      type: Type.PRODUCT_SPECIFIC,
      product: Product.TERM_LIFE_INSURANCE_CONSTANT,
      page: Page.QUOTE_SUMMARY,
      htmlTitle: getFullHtmlTitle($localize`Zusammenfassung`),
      pageTitle: $localize`Endspurt: Alles korrekt?`,
      pageSubtitle: $localize`Überprüfen Sie nochmals alle unten stehenden Angaben. Im nächsten Schritt erhalten Sie Ihren Antrag.`,
      funnelHeaderMilestones: allFunnelHeaderMilestones,
      navigation: {
        previousNavigationPage: {
          pagePath: occupationsPagePath,
        },
        nextNavigationPage: {
          pagePath: applicationPdfPagePath,
        },
      },
      dataAnalytics: {
        funnelStepNumber: TermLifeInsuranceSharedFunnelStepNumber.QUOTE_SUMMARY,
      },
    },
    resolve: {
      termLifeInsuranceQuote:
        getTermLifeInsuranceQuoteWithProductConfigurationResolver,
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver:
        extractQueryStringParametersResolver,
    },
  },
];
